import defaultEventDispatcher from './event_dispatcher/default_dispatcher.node';
import { FAILED_EVENT_RETRY_INTERVAL, getOpaqueBatchEventProcessor, getPrefixEventStore, wrapEventProcessor, getForwardingEventProcessor, } from './event_processor_factory';
export const DEFAULT_EVENT_BATCH_SIZE = 10;
export const DEFAULT_EVENT_FLUSH_INTERVAL = 30000;
export const EVENT_MAX_RETRIES_NODE = 2;
export const createForwardingEventProcessor = (eventDispatcher = defaultEventDispatcher) => {
    return wrapEventProcessor(getForwardingEventProcessor(eventDispatcher));
};
export const createBatchEventProcessor = (options = {}) => {
    var _a;
    const eventStore = options.eventStore ? getPrefixEventStore(options.eventStore) : undefined;
    return getOpaqueBatchEventProcessor({
        eventDispatcher: options.eventDispatcher || defaultEventDispatcher,
        closingEventDispatcher: options.closingEventDispatcher,
        flushInterval: options.flushInterval,
        batchSize: options.batchSize,
        defaultFlushInterval: DEFAULT_EVENT_FLUSH_INTERVAL,
        defaultBatchSize: DEFAULT_EVENT_BATCH_SIZE,
        retryOptions: {
            maxRetries: (_a = options.maxRetries) !== null && _a !== void 0 ? _a : EVENT_MAX_RETRIES_NODE,
        },
        failedEventRetryInterval: eventStore ? FAILED_EVENT_RETRY_INTERVAL : undefined,
        eventStore,
    });
};
export const __platforms = ['node'];
//# sourceMappingURL=event_processor_factory.node.js.map